export default "__VITE_ASSET__Dj7ABlk8__"